import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {Bonus} from '../model/bonus.model';
import {Router} from '@angular/router';
import {StateService} from '../state.service';
import {Field} from '../model/field.model';

@Component({
    selector: 'app-bonus',
    templateUrl: './bonus.component.html',
    styleUrls: ['./bonus.component.css'],
    standalone: false
})
export class BonusComponent {

  bonuses: Observable<Bonus[]>;
  private fields: Field[];

  constructor(private router: Router, private stateService: StateService) {
    this.fields = stateService.fields;
    this.bonuses = stateService.getBonuses();
  }

  editBonus(bonus: Bonus) {
    this.stateService.bonus = bonus;
    this.router.navigate( ['editBonus']);
  }

  deleteBonus(bonus: Bonus) {
    this.stateService.deleteBonus(bonus);
  }

  addBonus() {
    this.router.navigate( ['addBonus']);
  }

  getFieldName(fieldId: string) {
    for (const field of this.fields) {
      if (field.id === fieldId) {
        return field.name;
      }
    }
  }
}
